import React from 'react'

import clsx from 'clsx'

import InteractiveElement from '$extensionSrc/components/InteractiveElement'
import StepRow from '$extensionSrc/components/Sidebar/RecommendationCards/RecommendationCardContainer/RecommendationCard/ManualBody/StepRow'
import { RecommendationState } from '$extensionSrc/utils/enums'
import { getLogoFromPlatform } from '$extensionSrc/utils/platformMetadataUtils'

import './ManualRecommendationCardPreview.scss'

export default function ManualRecommendationCardPreview({ platform, spec }) {
  const {
    recommendationTitle,
    concernTags,
    explanationText,
    bodyTitle,
    steps,
  } = spec

  const header = (
    <div className={clsx('recommendation-header')}>
      {getLogoFromPlatform(platform, 'platform-logo')}
      {concernTags.length > 0 && (
        <div className="concern-tags">
          <div className="concern-tag body3">{concernTags[0]}</div>
          {concernTags.length > 1 && (
            <div className="additional">
              <InteractiveElement
                aria-describedby="additional-concern-tags-tooltip"
                aria-label={`View ${concernTags.length - 1} more`}
                className="prompt body3 darker-gray"
              >
                + {concernTags.length - 1} more
              </InteractiveElement>
              <div
                className="tooltip-text body3"
                id="additional-concern-tags-tooltip"
                role="tooltip"
              >
                {concernTags.slice(1, concernTags.length).map((ct) => (
                  <div>{ct}</div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  )

  const stepRowsList = steps.map((step) => (
    <StepRow
      key={step.id}
      recommendationState={RecommendationState.INCOMPLETE}
      label={step.description}
      stepIndex={step.id + 1}
    />
  ))

  const content = (
    <div className="card-body">
      <div className="recommendation-body">
        <div className="recommendation-body-title">
          <div className="body1 black bold">{bodyTitle}</div>
        </div>
        <div className="steps">{stepRowsList}</div>
      </div>
    </div>
  )

  return (
    <div className="ManualRecommendationCardPreview">
      {header}
      <div className="recommendation-title-explanation">
        <div className="recommendation-title">
          <h3 className="heading3 bold black">{recommendationTitle}</h3>
        </div>
        <div className="recommendation-explanation-text">
          <span className="body2">{explanationText}</span>
        </div>
      </div>
      {content}
    </div>
  )
}
